import { format } from 'date-fns';
import { es } from 'date-fns/locale';

export const SLOT_DURATION = 30;

export const formatPrice = (price) => {
  if (price === undefined || price === null) return 'N/A';
  return `Gs ${Number(price).toLocaleString('es-PY')}`;
};

export const formatDuration = (minutes) => {
  if (!minutes || minutes === 0) return '0m';
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (hours > 0 && remainingMinutes > 0) return `${hours}h ${remainingMinutes}m`;
  else if (hours > 0) return `${hours}h`;
  else return `${remainingMinutes}m`;
};

export const formatDate = (dateStr) => {
    try {
      const date = new Date(dateStr + 'T00:00:00');
      return format(date, 'EEE d MMM', { locale: es });
    } catch (e) {
      return 'Fecha Inválida';
    }
};

// 👇 AQUÍ ESTÁ LA CORRECCIÓN DE COLORES
export const getStatusColor = (status) => {
    switch (status) {
        case 'confirmed': return 'bg-blue-600 border-blue-500';
        case 'pending': return 'bg-yellow-500 border-yellow-400';
        case 'in_progress': return 'bg-purple-600 border-purple-500'; // Morado para En Vivo
        case 'completed': return 'bg-green-600 border-green-500';
        case 'cancelled': return 'bg-red-600 border-red-500';
        case 'no_show': return 'bg-gray-600 border-gray-500'; // ✅ AHORA SÍ EXISTE (Gris Oscuro)
        default: return 'bg-gray-700 border-gray-600';
    }
};
  
// 👇 AQUÍ ESTÁ LA CORRECCIÓN DE TEXTO
export const getStatusText = (status) => {
    switch (status) {
        case 'confirmed': return 'Confirmado';
        case 'pending': return 'Pendiente';
        case 'in_progress': return 'En Proceso';
        case 'completed': return 'Completado';
        case 'cancelled': return 'Cancelado';
        case 'no_show': return 'No Asistió'; // ✅ AHORA SÍ EXISTE
        default: return 'Desconocido';
    }
};

export const getStatusTextColor = (status) => {
    // El amarillo suele requerir texto negro para leerse bien, el resto blanco
    if (status === 'pending') return 'text-black';
    if (status === 'no_show') return 'text-gray-300'; // Color gris claro para el texto
    return 'text-white';
};